export default function ProMindLogo({

  size = "normal",
  subtle = false

}) {

  const sizes = {

    small: {
      circle: 14,
      line: 18,
      text: 28,
      gap: 14
    },

    normal: {
      circle: 18,
      line: 24,
      text: 42,
      gap: 16
    },

    hero: {
      circle: 22,
      line: 30,
      text: 56,
      gap: 20
    }

  };

  const s = sizes[size] || sizes.normal;

  return (

    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: `${s.gap}px`
      }}
    >

      {/* ORIENTATION MARKER */}

      <div
        style={{
          position: "relative",
          width: `${s.circle}px`,
          height: `${s.circle}px`,
          borderRadius: "9999px",
          border: "2px solid #8A2F3C",
          flexShrink: 0,
          opacity: subtle ? 0.82 : 1
        }}
      >

        <div
          style={{
            position: "absolute",
            left: "50%",
            top: `-${s.line}px`,
            width: "2px",
            height: `${s.line}px`,
            background: "#8A2F3C",
            transform: "translateX(-50%)"
          }}
        />

        <div
          style={{
            position: "absolute",
            left: "50%",
            bottom: `-${s.line}px`,
            width: "2px",
            height: `${s.line}px`,
            background: "#8A2F3C",
            transform: "translateX(-50%)"
          }}
        />

      </div>

      {/* WORDMARK */}

      <div
        style={{
          fontSize: `${s.text}px`,
          fontWeight: 500,
          letterSpacing: "-0.04em",
          color: "#1F1F1F",
          lineHeight: 1
        }}
      >
        ProMind
      </div>

    </div>

  );

}
